import * as React from 'react';
import DialogActions from '@material-ui/core/DialogActions';

const CustomDialogActions = (props) => {
    return <DialogActions {...props} />;
};

export { CustomDialogActions as DialogActions };
